/**
 * Canonical list of question category slugs. Kept in sync with the seed
 * buckets in `games/word-clash/server/seeds/questions/*.ts` and the recategoriser in
 * `games/word-clash/server/seeds/questions/index.ts::inferCategory()`.
 *
 * `label` is just a prettified version of the slug for display in the
 * admin combobox — the DB stores the slug. Admins can still type an
 * unknown slug into the combobox (free-text) to keep the field flexible
 * when a new category bucket is introduced before this list is updated.
 */

export interface QuestionCategory {
  slug: string;
  label: string;
}

export const KNOWN_CATEGORIES: ReadonlyArray<QuestionCategory> = [
  { slug: 'general', label: 'General' },
  { slug: 'abstract_creative', label: 'Abstract & creative' },
  { slug: 'animals_nature', label: 'Animals & nature' },
  { slug: 'celebrations', label: 'Celebrations' },
  { slug: 'entertainment', label: 'Entertainment' },
  { slug: 'everyday_life', label: 'Everyday life' },
  { slug: 'fashion_style', label: 'Fashion & style' },
  { slug: 'food_drink', label: 'Food & drink' },
  { slug: 'funny_hypothetical', label: 'Funny & hypothetical' },
  { slug: 'history_culture', label: 'History & culture' },
  { slug: 'home_routines', label: 'Home & routines' },
  { slug: 'places_travel', label: 'Places & travel' },
  { slug: 'prefix_containing', label: 'Prefix — containing' },
  { slug: 'prefix_ending', label: 'Prefix — ending' },
  { slug: 'prefix_starting', label: 'Prefix — starting' },
  { slug: 'professional', label: 'Professional' },
  { slug: 'science_tech', label: 'Science & tech' },
  { slug: 'social_situations', label: 'Social situations' },
  { slug: 'sports_outdoors', label: 'Sports & outdoors' },
  { slug: 'words_language', label: 'Words & language' },
];

export function categoryLabel(slug: string): string {
  return KNOWN_CATEGORIES.find((c) => c.slug === slug)?.label ?? slug;
}
